import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAccountUsage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path d="M4.653 10.93c-.4.39-1.05.39-1.449-.001a.983.983 0 0 1 .002-1.414l3.442-3.352c.4-.39 1.049-.39 1.449 0l1.927 1.883 1.398-1.365 2.184-2.143h-.994a1.01 1.01 0 0 1-1.024-1c0-.553.459-1 1.024-1h4.483v4.55c0 .553-.458 1-1.024 1a1.01 1.01 0 0 1-1.025-1V5.961l-2.172 2.13-.002.003-2.124 2.073a1.04 1.04 0 0 1-.725.293c-.272 0-.532-.105-.724-.293L7.37 8.284l-2.718 2.647Z" />
    <path
      fillRule="evenodd"
      d="M2.757 17.816c-.292-.293-.292-.764-.292-1.707v-1.397c0-.942 0-1.414.292-1.707.293-.293.765-.293 1.708-.293h11.07c.943 0 1.415 0 1.708.293s.293.765.293 1.707v1.397c0 .943 0 1.414-.293 1.707s-.765.293-1.707.293H4.465c-.943 0-1.415 0-1.708-.293m12.91-2.405a.941.941 0 1 1-1.882 0 .941.941 0 0 1 1.883 0Zm-3.649.941a.941.941 0 1 0 0-1.882.941.941 0 0 0 0 1.882"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAccountUsage;
